import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Feather, ArrowRight } from "lucide-react";

export default function SimplerOffer({ offer, onAnswer }) {
  const [busy, setBusy] = useState(null);
  if (!offer) return null;
  const answer = async (a) => { setBusy(a); await onAnswer(a); setBusy(null); };
  return (
    <AnimatePresence>
      <motion.section initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.6 }}
        className="mb-12 rounded-3xl border border-primary/25 bg-primary/[0.05] p-5 sm:p-6" data-testid="routine-simpler-offer">
        <p className="text-[10px] uppercase tracking-[0.22em] text-primary flex items-center gap-1.5"><Feather className="w-3 h-3" /> A lighter rhythm</p>
        <p className="font-serif text-lg sm:text-xl leading-snug mt-2 mb-4" data-testid="simpler-offer-message">{offer.message}</p>
        <div className="space-y-3 mb-5">
          {offer.items.map((i) => (
            <div key={i.id} className="text-sm" data-testid={`simpler-offer-item-${i.id}`}>
              <span className="text-muted-foreground line-through decoration-white/50">{i.from_label}</span>
              <ArrowRight className="inline w-3.5 h-3.5 mx-2 text-primary" />
              <span className="text-foreground">{i.label}</span> <span className="text-xs text-muted-foreground">· {i.duration}</span>
              <span className="block text-xs text-muted-foreground mt-0.5">{i.tagline}</span>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button size="sm" className="rounded-full" disabled={!!busy} onClick={() => answer("accept")} data-testid="simpler-offer-accept">Make it lighter</Button>
          <Button size="sm" variant="outline" className="rounded-full" disabled={!!busy} onClick={() => answer("keep")} data-testid="simpler-offer-keep">Keep as is</Button>
          <Button size="sm" variant="ghost" className="rounded-full text-muted-foreground" disabled={!!busy} onClick={() => answer("later")} data-testid="simpler-offer-later">Not now</Button>
        </div>
      </motion.section>
    </AnimatePresence>
  );
}
